import { buildCoverSheetConfig } from '../../shared';
import { BaseLandlordConfig, type LandlordLocaleOverrides } from './base';
import { overrides } from './overrides';

/**
 * Builds the coversheet config for a landord lease.
 * @param locale Locale code, e.g. CA
 * @returns Coversheet config for specified locale
 */
export function buildLandlordCoverSheetConfig(locale: string) {
  const localeOverrides: LandlordLocaleOverrides = overrides[locale] ?? {
    locale,
  };
  return buildCoverSheetConfig(BaseLandlordConfig, localeOverrides);
}
